import { JetView } from 'webix-jet';
import {
    profile, // User profile settings
    devConfig, // Development configuration settings
    countries, // List of countries
    paymentSystem, // Payment system configurations
    cashDesks, // Cash desk configurations
    agentList, // List of agents
} from 'config/config';

/**
 * FilterClaimsView class extends JetView to create a filter interface for claims.
 */
export default class FilterClaimsView extends JetView {
    /**
     * Configures the view layout and components.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const left = {
            margin: 5,
            id: 'a1',
            rows: [
                {
                    margin: 15,
                    css: 'on-row',
                    responsive: 'a1',
                    cols: [
                        {
                            view: 'text', // Input field for User ID
                            name: 'UserId',
                            type: 'number',
                            minWidth: 200,
                            label: "<span class='icon-drivers-license-o'></span>" + _('ID Usuario'),
                            hidden: !devConfig.getPermAction('filterByUser', 'Add'), // Visibility based on permissions
                            css: 'prm-filterByUser',
                            labelPosition: 'top',
                            placeholder: _('ID Usuario'),
                        },
                        {
                            view: 'datepicker', // Date picker for Year selection
                            name: 'Year',
                            id: 'Year',
                            stringResult: false,
                            minWidth: 200,
                            type: 'year',
                            label: "<span class='webix_icon icon-calendar'></span>" + _('Año'),
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '),
                            value: new Date(), // Default to current date
                            format: '%Y',
                        },
                        {
                            view: 'richselect', // Dropdown for country selection
                            name: 'CountrySelect',
                            id: 'CountrySelect',
                            label: "<span class='icon-language'></span>" + _('País'),
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '),
                            options: {
                                body: {
                                    template: function (obj) {
                                        return "<i class='flags " + obj.icon + "'></i>" + obj.value;
                                    },
                                    data: countries, // Country data
                                },
                            },
                            hidden: devConfig.getCountryReport() || !devConfig.getPermAction('filterByCountry', 'Add'), // Visibility based on permissions
                            css: 'prm-filterByCountry',
                        },
                        {
                            view: 'richselect', // Read-only dropdown for country selection
                            name: 'CountrySelect2',
                            label: "<span class='icon-language'></span>" + _('País'),
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '),
                            value: profile.Settings.ReportCountry, // Default value from profile settings
                            readonly: true,
                            options: {
                                body: {
                                    template: function (obj) {
                                        return "<i class='flags " + obj.icon + "'></i>" + obj.value;
                                    },
                                    data: countries, // Country data
                                },
                            },
                            hidden: !devConfig.getCountryReport() || !devConfig.getPermAction('filterByCountry', 'Add'), // Visibility based on permissions
                            css: 'prm-filterByCountry country-hide',
                        },
                    ],
                },
                {
                    margin: 15,
                    css: 'on-row',
                    responsive: 'a1',
                    cols: [
                        {
                            view: 'richselect', // Dropdown for filled out status
                            name: 'IsFilledOut',
                            label: "<span class='icon-state'></span>" + _('Diligenciado'),
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '),
                            options: [
                                { id: '0', value: _('Sí') },
                                { id: '1', value: _('No') },
                            ],
                        },
                        {
                            view: 'richselect', // Dropdown for type selection
                            name: 'Type',
                            label: "<span class='icon-state'></span>" + _('Tipo'),
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '),
                            options: [{ id: 'SPLAFT', value: _('SPLAFT') }],
                        },
                    ],
                },
            ],
        };
        const upper_section = {
            css: 'father-container',
            height: document.body.offsetWidth < 500 ? 190 : 0, // Responsive height
            rows: [
                {
                    margin: 10,
                    cols: [left], // Left section with filters
                },
            ],
        };
        const buttons = {
            id: 'b2',
            rows: [
                {
                    margin: 10,
                    responsive: 'b2',
                    cols: [
                        { id: 'grav', gravity: 4 }, // Spacer
                        {
                            minWidth: 200,
                            view: 'button', // Clear button
                            value: _('Limpiar'),
                            width: screen == 'small' ? 0 : 100,
                            click: () => {
                                this.getRoot().clear(); // Clear form values
                            },
                        },
                        {
                            minWidth: 200,
                            view: 'button', // Consult button
                            value: _('Consultar'),
                            type: 'form',
                            width: screen == 'small' ? 0 : 100,
                            click: () => {
                                const filterdata = this.getRoot().getValues(); // Get form values
                                if (devConfig.getCountryReport()) {
                                    filterdata.CountrySelect = profile.Settings.ReportCountry; // Set country if report is enabled
                                }
                                delete filterdata['CountrySelect2']; // Remove unused field
                                this.app.callEvent('managementContact:filter', [filterdata]); // Trigger filter event
                            },
                        },
                    ],
                },
            ],
        };
        const buttons2 = {
            padding: 10,
            cols: [
                {
                    view: 'button', // Clear button for second form
                    value: _('Limpiar'),
                    click: () => {
                        $$('myForm2').clear(); // Clear form values
                    },
                },
                {
                    view: 'button', // Consult button for second form
                    value: _('Consultar'),
                    type: 'form',
                    click: () => {
                        const filterdata = $$('myForm2').getValues(); // Get form values
                        if (devConfig.getCountryReport()) {
                            filterdata.CountrySelect = profile.Settings.ReportCountry; // Set country if report is enabled
                        }
                        delete filterdata['CountrySelect2']; // Remove unused field
                        this.app.callEvent('managementContact:filter', [filterdata]); // Trigger filter event
                        $$('filterPopup').hide(); // Hide popup after consultation
                    },
                },
            ],
        };
        const accordion_section2 = {
            type: 'wide',
            rows: [
                {
                    multi: true,
                    view: 'accordion', // Accordion for filters
                    css: 'betShop',
                    collapsed: true,
                    type: 'clean',
                    rows: [
                        {
                            header: _('Filtros'), // Accordion header
                            id: 'b5',
                            body: {
                                padding: 10,
                                rows: [upper_section, buttons], // Upper section with filters and buttons
                            },
                        },
                    ],
                },
            ],
        };
        const accordion_section3 = {
            view: 'scrollview', // Scrollable view for filters
            scroll: 'xy',
            body: {
                padding: 10,
                rows: [upper_section], // Upper section with filters
            },
        };
        const filterPopup = webix.ui({
            // Popup window for filters
            view: 'window',
            move: true,
            id: 'filterPopup',
            fullscreen: true,
            head: {
                view: 'toolbar',
                cols: [
                    { view: 'label', label: _('Filtros'), align: 'center' }, // Popup title
                    {
                        view: 'icon',
                        icon: 'wxi-close',
                        click: function () {
                            this.getTopParentView().hide(); // Close popup
                        },
                    },
                ],
            },
            modal: true,
            position: 'center',
            body: {
                view: 'form',
                id: 'myForm2',
                type: 'clean',
                rows: [accordion_section3, buttons2], // Accordion and buttons in popup
                rules: {
                    fname: webix.rules.isNotEmpty, // Validation rule
                },
            },
        });
        return {
            view: 'form',
            type: 'clean',
            rows: [
                screen.width > 500 && screen.height > 500
                    ? accordion_section2 // Show accordion if screen size is sufficient
                    : { height: 1, width: 0 },
            ],
            rules: {
                fname: webix.rules.isNotEmpty, // Validation rule
            },
        };
    }
}

// FILE DOCUMENTED
